import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Container,
  Fade,
  Paper,
} from "@mui/material";
import { LoginRounded } from "@mui/icons-material";
import { checkAuthentication } from "../../components/auth/RequireAuth";
import { baseURL } from "../../api/apiClient";

const Login: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = checkAuthentication();
    if (isAuthenticated) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <Fade in timeout={1000}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundImage: `url('/bg.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container maxWidth="xs">
          <Card
            sx={{
              minHeight: 200,
              backdropFilter: "blur(10px)",
              backgroundColor: "rgba(0,0,0,0.3)",

              boxShadow: (theme) =>
                `0 8px 32px ${theme.palette.primary.main}20`,
              borderRadius: 2,
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                boxShadow: (theme) =>
                  `0 12px 48px ${theme.palette.primary.main}30`,
              },
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: 4,
                gap: 3,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "65px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 2,
                }}
              >
                <img src="/logo192.png" />
              </Box>

              <Typography
                variant="h2"
                sx={{
                  fontWeight: "bold",
                  backgroundClip: "text",
                  color: "white",
                  WebkitBackgroundClip: "text",
                }}
              >
                Securisea
              </Typography>

              <Typography variant="h4" color="white">
                Evidence Portal
              </Typography>

              <Button
                variant="contained"
                size="large"
                href={`${baseURL}/auth/amazon-cognito/login/?process=login`}
                sx={{
                  mt: 2,
                  py: 1.5,
                  px: 4,
                  borderRadius: 2,
                  textTransform: "none",
                  fontSize: "1.1rem",
                  fontWeight: "medium",
                  boxShadow: (theme) =>
                    `0 4px 14px ${theme.palette.primary.main}40`,
                  transition: "all 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: (theme) =>
                      `0 6px 20px ${theme.palette.primary.main}60`,
                  },
                }}
                startIcon={<LoginRounded />}
              >
                Proceed to Login
              </Button>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </Fade>
  );
};

export default Login;
